<template>
	<div class="">
		<div class="row">
	    <div class="row col-md-12">
          <div class="col-md-4 form-group">
            <label>Report Date</label>
            <!-- <date-picker input-class="form-control" ref="report_date" value-type="format" type="date" v-model="report_date" format='DD-MM-YYYY'></date-picker> -->
            <date-picker input-class="form-control" ref="report_date" value-type="format" :range='dateRange' type="date" v-model="report_date" format='DD-MM-YYYY'>
              <template v-slot:footer="{emit}">
                <div style="text-align: left">
                  <button class="mx-btn mx-btn-text" @click="chooseLastMonth(emit)">
                    Choose {{dateRange?'single date':'last month'}}
                  </button><br />
                  <button v-if="!dateRange" class="mx-btn mx-btn-text" @click="dateRange=(dateRange?false:true);report_date=''">
                    Choose range
                  </button>
                </div>
              </template>
            </date-picker>
          </div>
          <div class="col-md-2 form-group">
            <label>Base Currency</label>
            <b-form-select
              class="form-control"
              :options="currencies"
              v-model="base_currency"
            ></b-form-select>
          </div>
          <div class="col-md-6 mt-4">
            <a class="pull-right ml-2" target="_blank" ref="download" :href="DownloadURL" @click.prevent="send_report"><i class="fa fa-send"></i> Send Client Report</a> 
            <a class="pull-right" target="_blank" ref="download" href="javascript:;" @click.prevent="download"><i class="fa fa-file"></i> Generate Report</a>
            <a class="pull-right mr-2" href="javascript:;" @click="get_report_modal" title="Download Reports" v-if="can_access('report','download')"><i class="fa fa-archive" aria-hidden="true"></i> Download From Archives</a>
          </div>
      </div>
      <div class="col-md-12">
        <b-card no-body class="box-shadow" v-if="ViewReports">
          <b-tabs>
            <b-tab @click="activeTab='trade_history'" :active="activeTab=='trade_history'" title="Trade History" v-if="can_access('deal','view')">
              <TableView :col="columns" :getData="getData" :Options="{tblContainerClass:'innerTable-style'}"/>                
            </b-tab>
            <b-tab @click="activeTab='portfolio_report'" :active="activeTab=='portfolio_report'" title="Portfolio Summary Report" v-if="can_access('report','view')">
              <PortfolioSummaryReport :row="row" :report_date="report_date" :base_currency="base_currency"/>              
            </b-tab>
            <b-tab @click="activeTab='cash_activity_report'" :active="activeTab=='cash_activity_report'" title="Cash Activity Report" v-if="can_access('report','view')">
              <CashActivityReport :row="row" :report_date="report_date" :base_currency="base_currency"/>              
            </b-tab>
            <b-tab @click="activeTab='bal_summary_report'" :active="activeTab=='bal_summary_report'" title="Balance Summary Report" v-if="can_access('report','view')">
              <BalanceSummaryReport :row="row" :report_date="report_date" :base_currency="base_currency"/>              
            </b-tab>
            <b-tab @click="activeTab='trade_activity_report'" :active="activeTab=='trade_activity_report'" title="Trade Activity Report" v-if="can_access('report','view')">
              <TradeActivityReport :row="row" :report_date="report_date" :base_currency="base_currency"/>              
            </b-tab>
            <b-tab @click="activeTab='settled_security_report'" :active="activeTab=='settled_security_report'" title="Settled Securities Report" v-if="can_access('report','view')">
              <SettledSecuritiesReport :row="row" :report_date="report_date" :base_currency="base_currency"/>              
            </b-tab>
          </b-tabs>
        </b-card>
      </div>

	    <!-- <div class="col-md-3">
	        <div class="wrapper wrapper-content project-manager">
	            <h5>Uploaded Docs</h5>
	            <ul class="list-unstyled project-files">
	                <li><a href=""><i class="fa fa-file"></i> Project_document.docx</a><p style="float:right">verified</p></li>
	            </ul>
	            <div class="text-center m-t-md">
	                <a href="javascript:;" class="btn btn-xs btn-primary" @click="nested.$toggle('UploadDocs', true)">Add files</a>
	            </div>
	        </div>
	    </div> -->
		</div>
    <b-modal ref="get_filename" :title="'Set Filename'" size="md" hide-footer @hidden="setFilename">
      <div class="form-group">
        <label>Filename</label>
        <b-input-group>
          <template v-slot:prepend v-if="filenameprefix">
            <b-input-group-text >{{filenameprefix}}</b-input-group-text>
          </template>
          <b-form-input ref="file_name" v-model="filename" placeholder="Enter filename here.."></b-form-input>
          <template v-slot:append>
            <b-form-select v-model="filetype" :options="filetype_options"></b-form-select>
          </template>
        </b-input-group>
        <button type="button" class="btn btn-lg btn-info pull-right mt-2" @click="download($event,'click')">Generate</button>
      </div>

    </b-modal>

    <b-modal ref="send_report" :title="'SEND REPORT'" size="lg" hide-footer @hidden="setFilename">
      <div class="form-group">
          <label class="col-lg-2 control-label">To</label>
          <div class="col-lg-12">
              <input type="text" placeholder="" :value="row.email" :readonly="true" class="form-control">
          </div>
      </div>
      <div class="form-group">
          <label class="col-lg-2 control-label">Subject</label>
          <div class="col-lg-12">
              <input type="text" placeholder="" v-model="email_subject" class="form-control">
          </div>
      </div>
      <div class="form-group">
          <label class="col-lg-2 control-label">Message</label>
          <div class="col-lg-12">
              <vue-editor v-model="email_body" :editorToolbar="customToolbar"></vue-editor>
          </div>
      </div>
      <div class="form-group">
          <label class="col-lg-2 control-label">Attachment(s):</label>
          <div class="col-lg-12" v-if="email_attachments">
              <a class="" v-for="file in email_attachments" :key="file" target="_blank"  :href="get_baseURL()+file"><i class="fa fa-file-pdf-o pdf-icon" aria-hidden="true"></i></a>
          </div>
      </div>

      <div class="form-group">
        <div class="col-lg-12">
          <button type="button" class="btn btn-lg btn-info pull-right mt-2" @click.prevent="send_report($event,'send')">Send</button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="get-report-out" title="Download Reports" size="xl" hide-footer>
      <ReportsInExcel :file_prefix="filenameprefix"/>
    </b-modal>
	</div>
</template>
<script>
import common from '@/assets/js/common.js';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import { mapActions } from 'vuex';
import { VueEditor } from "vue2-editor";

export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
    PortfolioSummaryReport : () => import('@/components/Accounts/PortfolioSummaryReport.vue') ,
    BalanceSummaryReport : () => import('@/components/Accounts/BalanceSummaryReport.vue') ,
    CashActivityReport : () => import('@/components/Accounts/CashActivityReport.vue') ,
    TradeActivityReport : () => import('@/components/Accounts/TradeActivityReport.vue') ,
    SettledSecuritiesReport : () => import('@/components/Accounts/SettledSecuritiesReport.vue') ,
    DatePicker : () => import('vue2-datepicker'),
    ReportsInExcel : () => import('@/components/Accounts/ReportsInExcel.vue'),
    VueEditor
  },
  mixins: [common],
  props: ['row', 'nested'],
  data(){
  	return {
      ViewReports : true,
      dateRange: false,
      activeTab: 'trade_history',
      DownloadURL: '',
      filenameprefix:'axcap_summary-'+this.row.account_number,
      filename:'',
      filetype:'pdf',
      filetype_options:[{ value: 'xlsx', text: '.xlsx' },{ value: 'pdf', text: '.pdf' }],
      email_subject: '',
      email_body: null,
      email_attachments: {},
      customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
  		clustered_info_1: [],
  		clustered_info_2: [],
      report_date: this.getLastWorkingDate(),
      base_currency: 'GBP',
      currencies: [{value: 'GBP', text: 'British Pound (GBP)'},{value: 'USD',text: 'US Dollar (USD)'}],
      columns: (() => {
        const cols = [
          { title: 'Contract Note', field: 'contract_note', label: 'User ID', visible: 'true', tdClass:"p1rem", thComp: 'FilterTh'},
          { title: 'Ticket Number', field: 'ticket_number', thComp: 'FilterTh' },
          { title: 'Ticker', field: 'stock', 'nested': 'tidm', thComp: 'FilterTh'},
          { title: 'Issuer Name', field: 'stock', 'nested': 'issuer_name', thComp: 'FilterTh'},
          { title: 'Quantity', field: 'total_quantity', tdComp: 'Number', thComp: 'FilterTh', 'floatLength': 2},
          { title: 'Type', field: 'type', thComp: 'FilterTh', tdStyle: (row) => {if(["BUY","DEPOSIT","DIVIDENDS","FOP IN","TRANSFER IN","FX",'GIVE IN','DVP IN'].indexOf(row.type)>=0) return {color: "green"};else /* if(["SELL","WITHDRAWAL","TRANSFER OUT","FOP OUT"].indexOf(row.type)>=0) */ return {color: 'red'};}},
          { title: 'Currency', field: 'currency', thComp: 'FilterTh'},
          { title: 'Trade Price', field: 'trade_price', sortable: true, tdComp: 'Number' },
          { title: 'Trade Value', field: 'trade_value', sortable: true, tdComp: 'Number', 'floatLength': 2},
          { title: 'Trade Date', field: 'trade_date', sortable: true , thComp: 'FilterTh'},
          { title: 'Settlement Date', field: 'settlement_date', sortable: true, thComp: 'FilterTh' },
          /* { title: 'Cost Price', field: 'cost_price', tdComp: 'Number' }, */
          { title: 'Cosideration', field: 'total_consideration', tdComp: 'Number', 'floatLength': 2 },
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  watch:{
    "report_date": function(){
      this.ViewReports = false;
      this.$nextTick(function(){
          this.ViewReports = true;
          this.DownloadURL = this.get_baseURL() +'download_client_report?api_token='+ window.localStorage.getItem('auth_token')+'&report_date='+this.report_date+'&base_cur='+this.base_currency+'&account_number='+this.row.account_number;
        });
    },
    "base_currency": function(){
      this.ViewReports = false;
      this.$nextTick(function(){
        this.ViewReports = true;
        this.DownloadURL = this.get_baseURL() +'download_client_report?api_token='+ window.localStorage.getItem('auth_token')+'&report_date='+this.report_date+'&base_cur='+this.base_currency+'&account_number='+this.row.account_number;
      });
    }
  },
  created() {
    //this.cluster_info()
    this.DownloadURL = this.get_baseURL() +'download_client_report?api_token='+ window.localStorage.getItem('auth_token')+'&report_date='+this.report_date+'&base_cur='+this.base_currency+'&account_number='+this.row.account_number;
  },
  methods: {
    ...mapActions('layout', ['changeBodyLoading']),
  	cluster_info(){
  		let other_infos = [
  			{ title: 'Alt. Phone Number', field: 'alt_phone_no'},
  			{ title: 'NI Number', field: 'ni_number'},
  			{ title: 'Address', field: 'address'},
  			{ title: 'City', field: 'city'},
  			{ title: 'State', field: 'state'},
  			{ title: 'Country', field: 'country'},
  			{ title: 'Zip', field: 'zip'},
  			{ title: 'No. Of Years In Address', field: 'no_of_years_in_address'},
  			{ title: 'Education', field: 'education'},
  			{ title: 'Employee Status', field: 'employee_status'},
  			{ title: 'Occupation', field: 'occupation'},
  			{ title: 'Employee Sector', field: 'employment_sector'},
  			{ title: 'Annual Income', field: 'annual_income'},
  			{ title: 'Size Of Investment', field: 'size_of_investment'},
  			{ title: 'Funding Method', field: 'funding_method'},
  			{ title: 'Security Type', field: 'security_type'},
  			{ title: 'How Much You Invest Per Year', field: 'how_much_you_invest_per_year'},
  			{ title: 'How Do You Know About Us', field: 'how_do_you_know_about_us'},
  			{ title: 'Initial Deposit Amount', field: 'initial_deposit_amount'},
  			{ title: 'How Many Trades In Shares', field: 'how_many_trades_in_shares'},
  			{ title: 'How Many Trades In FX', field: 'how_many_trades_in_fx'},
  			{ title: 'How Many Trades In Equity Derivatives', field: 'how_many_trades_in_equity_derivatives'},
  			{ title: 'Have Req Knowledge In Trade', field: 'have_req_knowledge_in_trade'},
  			{ title: 'Have Trained For Training', field: 'have_trained_for_trade'},
  			{ title: 'Bank Account Name', field: 'bank_account_name'},
  			{ title: 'Bank Account Number', field: 'bank_account_number'},
  			{ title: 'Bank Account Sort Code', field: 'bank_account_sort_code'},
  			{ title: 'Read Terms And Conditions', field: 'read_terms_and_condtn'},
  			{ title: 'Read Warning Notice', field: 'risk_warning_notice'},
  			{ title: 'Read Privacy Policy', field: 'read_privacy_policy'},
  			{ title: 'We W\'ont Provide Advice In Trading', field: 'wont_provide_advice_in_trading'}
  		];
  		let infos = other_infos.filter(info => {
  			return (this.row.hasOwnProperty('other_details') && this.row.other_details.hasOwnProperty(info.field) && this.row.other_details[info.field]) || (this.row.hasOwnProperty(info.field) && this.row[info.field]);
  		});
  		infos.forEach((value , key) => {
  			if(infos.length/2<key){ this.clustered_info_2.push({title: value.title, value: this.row.hasOwnProperty(value.field) ? this.row[value.field] : this.row.other_details[value.field]}) }
  			else{ this.clustered_info_1.push({title: value.title, value: this.row.hasOwnProperty(value.field) ? this.row[value.field] : this.row.other_details[value.field]}) }
  		});
  	},
    async getData(query, filter) {
      var { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      if(!sort) sort = 'trade_date';
      this.columns.forEach(col => {
        if (query[col.nested||col.field]) {
          filter[col.nested||col.field] = query[col.nested||col.field];
        }else{
          delete filter[col.nested||col.field];
        }
      });
      filter['account_number'] = this.row.account_number;
      if(Array.isArray(this.report_date))
        filter['trade_date'] = {/* 'from_date': this.report_date[0], */'to_date':this.report_date[1]};
      else 
        filter['trade_date'] = {'to_date':this.report_date};
      filter['approved_at'] = {'from_date':'2000-01-01'};

      let uri = 'trade_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      return await this.call_axios(uri);
    },
    download(e,action=''){
      e.preventDefault();
      var url = new URL(this.DownloadURL);
      url.searchParams.set('filename',this.filename);
      if(!url.searchParams.get('filename')){
        this.filename = String(this.report_date).replace(',','-');
        this.$refs.get_filename.show();
        return;
      }
      url.searchParams.set('file_type',this.filetype);
      var filename = this.filename;
      this.$refs.get_filename.hide();
      this.DownloadURL = url;
      /* this.$nextTick(() => { */
        if(action){
          this.changeBodyLoading(true);
          //this.$refs.download.click();
          this.call_axios((url.href).replace(this.get_baseURL(),"")).then(res => {
            this.changeBodyLoading(false);
            if(res.response.code == '202'){
              this.$toasted.success("Please wait, you can download the report once generated.",{duration:2500});
              var checkForNewFile = setInterval(() => {
                  this.call_axios('get_report?file_prefix='+this.filenameprefix+'&filter='+JSON.stringify({filename: filename})).then(res => {
                    if(Object.keys(res.response.data.result).length){
                      this.$toasted.success("Your client report (for "+this.row.account_number+") has been generated.",{
                          action: {
                            text:'Download',
                            onClick:(e, toast) => {
                              window.open(this.get_baseURL() +'download_report?api_token='+ window.localStorage.getItem('auth_token')+'&filename='+this.filenameprefix+'-'+filename+'.'+this.filetype, '_blank');
                              toast.goAway(0);
                            }
                          },
                          duration: null
                      });
                      clearInterval(checkForNewFile)
                    }
                  })
              }, 5000);
              return;
            }
            else if(res.response.code == '503'){
              this.$toasted.error(this.row.account_number+" has no deal(s)!",{
                          action: {
                            onClick:(e, toast) => {
                              toast.goAway(0);
                            }
                          },duration:null});
              return;
            }
            this.$toasted.error("Something went wrong, please try again later.",{duration:2500});
          });
        }
      /* }) */
    },
    send_report(e,action=''){
      e.preventDefault();
      this.changeBodyLoading(true);
      if(action=='send'){
        this.call_axios('mail_client_summary','post',{email_id: this.email_id, subject: this.email_subject, body: this.email_body}).then(res => {
          this.changeBodyLoading(false);
          this.$refs.send_report.hide();
          if(res.response.code==0){
            this.$toasted.success("Mail sent successfully",{duration:1500});
            return
          }
          this.$toasted.success("Something went wrong",{duration:1500});
        });
      }
      else{
        var url = 'download_client_report?file_type=pdf&send_mail=1&report_date='+this.report_date+'&base_cur='+this.base_currency+'&account_number='+this.row.account_number;
        this.call_axios(url).then(response => {
          this.email_id = response.response.data.email_id;
          this.email_subject = response.response.data.email_subject;
          this.email_body = response.response.data.email_body;
          this.email_attachments = response.response.data.email_attachments_path;
          this.$refs.send_report.show();
          this.changeBodyLoading(false);
        });
      }
    },
    get_report_modal(){
      this.$refs['get-report-out'].show();
    },
    setFilename(name = ''){
      var url = new URL(this.DownloadURL);
      this.filename = '';
      url.searchParams.set('filename','');
    },
    chooseLastMonth(emit) {
      this.dateRange = this.dateRange?false:true;
      if(this.dateRange){
        const start = moment().subtract(1,'month').startOf('month').format('DD-MM-YYYY');
        const end = moment().subtract(1,'month').endOf('month').format('DD-MM-YYYY');
        this.report_date = [start, end];
        //emit(this.report_date);
      }
    },
  }
}
</script>
<style>
body{margin-top:20px;
background:#eee;
}
/* PROJECTS */
.project-people,
.project-actions {
  text-align: right;
  vertical-align: middle;
}
dd.project-people {
  text-align: left;
  margin-top: 5px;
}
.project-people img {
  width: 32px;
  height: 32px;
}
.project-title a {
  font-size: 14px;
  color: #676a6c;
  font-weight: 600;
}
.project-list table tr td {
  border-top: none;
  border-bottom: 1px solid #e7eaec;
  padding: 15px 10px;
  vertical-align: middle;
}
.project-manager .tag-list li a {
  font-size: 10px;
  background-color: white;
  padding: 5px 12px;
  color: inherit;
  border-radius: 2px;
  border: 1px solid #e7eaec;
  margin-right: 5px;
  margin-top: 5px;
  display: block;
}
.project-files li a {
  font-size: 11px;
  color: #676a6c;
  margin-left: 10px;
  line-height: 22px;
}

/* PROFILE */
.profile-content {
  border-top: none !important;
}
.profile-stats {
  margin-right: 10px;
}
.profile-image {
  width: 120px;
  float: left;
}
.profile-image img {
  width: 96px;
  height: 96px;
}
.profile-info {
  margin-left: 120px;
}
.feed-activity-list .feed-element {
  border-bottom: 1px solid #e7eaec;
}
.feed-element:first-child {
  margin-top: 0;
}
.feed-element {
  padding-bottom: 15px;
}
.feed-element,
.feed-element .media {
  margin-top: 15px;
}
.feed-element,
.media-body {
  overflow: hidden;
}
.feed-element > .pull-left {
  margin-right: 10px;
}
.feed-element img.img-circle,
.dropdown-messages-box img.img-circle {
  width: 38px;
  height: 38px;
}
.feed-element .well {
  border: 1px solid #e7eaec;
  box-shadow: none;
  margin-top: 10px;
  margin-bottom: 5px;
  padding: 10px 20px;
  font-size: 11px;
  line-height: 16px;
}
.feed-element .actions {
  margin-top: 10px;
}
.feed-element .photos {
  margin: 10px 0;
}
.feed-photo {
  max-height: 180px;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 10px;
  margin-bottom: 10px;
}
.file-list li {
  padding: 5px 10px;
  font-size: 11px;
  border-radius: 2px;
  border: 1px solid #e7eaec;
  margin-bottom: 5px;
}
.file-list li a {
  color: inherit;
}
.file-list li a:hover {
  color: #1ab394;
}
.user-friends img {
  width: 42px;
  height: 42px;
  margin-bottom: 5px;
  margin-right: 5px;
}

.ibox {
  clear: both;
  margin-bottom: 25px;
  margin-top: 0;
  padding: 0;
}
.ibox.collapsed .ibox-content {
  display: none;
}
.ibox.collapsed .fa.fa-chevron-up:before {
  content: "\f078";
}
.ibox.collapsed .fa.fa-chevron-down:before {
  content: "\f077";
}
.ibox:after,
.ibox:before {
  display: table;
}
.ibox-title {
  -moz-border-bottom-colors: none;
  -moz-border-left-colors: none;
  -moz-border-right-colors: none;
  -moz-border-top-colors: none;
  background-color: #ffffff;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
}
.ibox-footer {
  color: inherit;
  border-top: 1px solid #e7eaec;
  font-size: 90%;
  background: #ffffff;
  padding: 10px 15px;
}
ul.notes li,
ul.tag-list li {
  list-style: none;
}
.pdf-icon{
  font-size: 54px !important;
  color: red;
}
.ql-editor{
  background-color: #fff;
}                           
</style>
